import React, {
    useContext
}  from 'react';
import { AsgDictionaryContext } from '../../contexts';
import './SearchSectionTitle.css';

export const SearchSectionTitle = ({ title }) => {
    const dictionary = useContext(AsgDictionaryContext);

    return <div className="search-section__title">
        {dictionary.translate(title)}
    </div>;
};
